module.exports = __webpack_public_path__ + "img/River.4aeb8621.png";